import apontamentoColetasLocalizacaoReport from "entity/Indicador/reports/ApontamentoColetasLocalizacaoReport";
import apontamentoHeaderLocalizacaoReport from "entity/Indicador/reports/ApontamentoHeaderLocalizacaoReport";
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";
import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
import apontamentoPontosAmostradosReport from "entity/Indicador/reports/ApontamentoPontosAmostradosReport";
import TableReportHelper from "report/helper";

export default async function dcorReport(indicador, visita) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];

    for (const apontamento of apontamentos) {
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type);
        const paramItems = visita.cliente.getParamItems(IndicadorClass, apontamento.tipo);

        const configIndicador = {
            showTrator: true,
            showMeta: true,
            showImplemento: true,
            showFrente: false,
            addHeaderField: [
                {
                    field: "dosagemRecomendada",
                    label: "Dosagem",
                    width: 90,
                    valueGetter: (a) => {
                        return a.dosagemRecomendada;
                    },
                },
                {
                    field: "qtdBandejas",
                    label: "Quant. Bandejas",
                    width: 90,
                    valueGetter: (a) => {
                        return a.qtdBandejas;
                    },
                },
            ],
        };

        const additionalColumn = {
            label: "Operador",
            field: "operador.operador",
            width: "*",
        };

        content.push([
            await apontamentoHeaderLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                params,
                "Conformidade Média %",
                configIndicador,
                additionalColumn,
            ),

            await apontamentoColetasLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                ["Esquerda", "Conforme Esquerda", "Centro", "Conforme Centro", "Direita", "Conforme Direita"],
                (h) => [
                    h.numberField("esquerda", { digits: 3 }),
                    h.textField("conformeEsq"),
                    h.numberField("centro", { digits: 3 }),
                    h.textField("conformeCen"),
                    h.numberField("direita", { digits: 3 }),
                    h.textField("conformeDir"),
                ],
                ["*", "*", "*", "*", "*", "*"],
            ),
            apontamentoPontosAmostradosReport(visita, indicador, apontamento, paramItems, "cm"),
            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),

            h.space(),
        ]);
    }

    return content;
}
